'use client'

import { SessionProvider } from 'next-auth/react'
import { IntlProvider } from 'use-intl'
import { ToastProvider } from '@/components/ui/toast'
import { CommandPalette } from '@/components/CommandPalette'
import { AIProvider } from '@/context/AIContext'
import { RegionProvider } from '@/context/RegionContext'
import { AIManager } from '@/components/ai/AIManager'
import { TIME_ZONE } from '@/i18n/config'
import type { AppMessages, Locale } from '@/i18n/config'

interface ProvidersProps {
  children: React.ReactNode
  locale: Locale
  messages: AppMessages
}

export function Providers({ children, locale, messages }: ProvidersProps) {
  return (
    <IntlProvider locale={locale} messages={messages} timeZone={TIME_ZONE}>
      <SessionProvider
        basePath={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/api/auth`}
        // Refetch session every 4 minutes to keep tokens fresh
        // This triggers the JWT callback which handles token refresh
        refetchInterval={4 * 60}
        // Also refetch when user returns to the tab
        refetchOnWindowFocus={true}
      >
        <RegionProvider>
          <AIProvider>
            {children}
            <ToastProvider />
            <CommandPalette />
            <AIManager />
          </AIProvider>
        </RegionProvider>
      </SessionProvider>
    </IntlProvider>
  )
}
